import {
  Checkbox,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import React, { ChangeEvent, memo } from 'react';
import { useAuthUser } from '../../../../contexts/AuthProvider/hooks';
import { ListDecoratedMedisanteDevice } from '../../types';
import { useStyles } from './styles';
import WaitingIcon from '@material-ui/icons/WatchLater';
import { getValueByPropName } from '../../../../utils/helpers';
import { useHistory } from 'react-router-dom';
import DescriptionIcon from '@material-ui/icons/Description';

export const STRow = memo(
  ({
    device,
    tableColumns,
  }: {
    device: ListDecoratedMedisanteDevice;
    tableColumns: any[];
  }) => (
    <StyledTableRow key={device.id}>
      {tableColumns.map((column) => (
        <TableCell key={device.id + column.name}>
          {!!column.cell
            ? column.cell(device)
            : getValueByPropName(device, column.name)}
        </TableCell>
      ))}
    </StyledTableRow>
  ),
  (prevProps, nextProps) => {
    if (
      prevProps.device === nextProps.device &&
      prevProps.tableColumns === nextProps.tableColumns
    ) {
      return true; // Component will use cached value and not re-render
    }
    return false; // Component will re-render
  }
);

export const StyledTableRow = withStyles({
  root: {
    '& td': {
      padding: '0px 4px',
      '&:first-child': {
        padding: '0px 0px',
      },
    },
    '& th': {
      padding: '0px 4px',
      '&:first-child': {
        padding: '0px 0px',
      },
    },
  },
})(TableRow);

export const CheckboxHeader = ({
  someSelected,
  allSelected,
  onSelectAllChanged,
}: any) => {
  const { authUser } = useAuthUser();

  return authUser.selectedOrgs.length <= 1 ? (
    <Checkbox
      inputProps={{
        //@ts-ignore
        'data-testid': 'table-header-checkbox',
      }}
      indeterminate={someSelected}
      checked={allSelected}
      onChange={onSelectAllChanged}
    />
  ) : (
    <div style={{ padding: '25px' }} />
  );
};

export const CheckboxCell = ({
  isSelected,
  device,
  onSelectionChanged,
}: any) => {
  return (
    <Checkbox
      inputProps={{
        //@ts-ignore
        'data-testid': 'table-row-checkbox',
      }}
      checked={isSelected}
      onChange={(event: ChangeEvent) => {
        onSelectionChanged(device.id);
      }}
    />
  );
};

export const StateCell = ({ device, updateDeviceQueue }: any) => {
  const classes = useStyles();
  if (updateDeviceQueue) {
    const targetState = updateDeviceQueue[device.id];
    if (targetState) {
      return (
        <span
          className={[
            classes.updatingState,
            (targetState + '-device-state').toLowerCase(),
          ].join(' ')}
        >
          <WaitingIcon />
          {targetState}
        </span>
      );
    }
  }
  return <span>{device.state}</span>;
};

export const DetailsCell = ({ device }: any) => {
  const history = useHistory();
  return (
    <Tooltip title="Details" placement="left">
      <IconButton
        data-testid="details-button"
        onClick={() => {
          history.push(`/devices/${encodeURIComponent(device.id)}`);
        }}
      >
        <DescriptionIcon />
      </IconButton>
    </Tooltip>
  );
};
